export * from "./STSClient";
export * from "./STS";
export * from "./commands";
export * from "./models";
export * from "./defaultRoleAssumers";
export { STSServiceException } from "./models/STSServiceException";
